import React, { PureComponent } from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

let state, handleMonthChange;
class MonthPicker extends PureComponent {
  state = {
    selectedDate: this.props.startMonth ? this.props.startMonth : new Date(),
  };

  handleMonthChange = (date) => {
    this.setState({ selectedDate: date });
    this.props.monthChangeHandler(date);
  };

  render() {
    const { selectedDate } = this.state;
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          openTo="month"
          minDate={this.props.minDate ? moment(this.props.minDate) : moment(new Date()).subtract(2, "months")}
          maxDate={new Date()}
          views={["year", "month"]}
          label="Selected Month"
          value={selectedDate}
          renderDay={this.renderWrappedWeekDay}
          TextFieldComponent={this.props.renderInput}
          onChange={this.handleMonthChange}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export default MonthPicker;
